import React, { useEffect, useState } from 'react';
import { SignInButton } from '@clerk/react';
import { claimSignInBounce, marketingSignInUrl, navigation } from '../utils/signInRedirect';
import { freeAuditUrl } from '../utils/freeAudit';
import { T } from '../designTokens';

// ---------------------------------------------------------------------------
// The dashboard has no signed-out start page. A signed-out visitor on one of
// its own pages is sent to the marketing site's sign-in, which returns them
// here. If they were just sent there and came back still signed out, this
// app cannot read the session the marketing site made, so it offers its own
// sign-in rather than bouncing them in a loop.
// ---------------------------------------------------------------------------

function readSessionStorage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export default function SignedOutRedirect() {
  const [target] = useState(() => marketingSignInUrl(window.location.href));
  const [mayBounce] = useState(() => {
    const storage = readSessionStorage();
    return storage ? claimSignInBounce(storage, Date.now()) : true;
  });

  useEffect(() => {
    if (mayBounce) navigation.replace(target);
  }, [mayBounce, target]);

  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        backgroundColor: T.gray900,
        color: T.gray100,
      }}
    >
      {mayBounce ? (
        <p role="status" style={{ margin: 0, fontSize: '15px', color: T.gray300 }}>
          Taking you to sign in.{' '}
          <a href={target} style={{ color: T.cobalt300, textUnderlineOffset: '3px' }}>
            Continue
          </a>
        </p>
      ) : (
        <div style={{ maxWidth: '400px', width: '100%' }}>
          <h1
            style={{
              margin: '0 0 8px',
              fontFamily: T.fontDisplay,
              fontSize: '26px',
              fontWeight: 600,
              letterSpacing: '-0.01em',
              color: T.gray100,
            }}
          >
            Sign in to Privisy
          </h1>
          <p style={{ margin: '0 0 24px', fontSize: '15px', lineHeight: 1.6, color: T.gray400 }}>
            Your audits, reports and credits are in your account.
          </p>
          <SignInButton mode="modal">
            <button
              type="button"
              style={{
                minHeight: '48px',
                padding: '0 28px',
                fontSize: '16px',
                fontWeight: 600,
                color: T.white,
                backgroundColor: T.cobalt600,
                border: 'none',
                borderRadius: T.radiusMd,
                cursor: 'pointer',
              }}
            >
              Sign in
            </button>
          </SignInButton>
          <p style={{ margin: '24px 0 0', fontSize: '14px', color: T.gray400 }}>
            New to Privisy?{' '}
            <a href={freeAuditUrl()} style={{ color: T.cobalt300, textUnderlineOffset: '3px' }}>
              Run a free audit on getprivisy.com
            </a>
          </p>
        </div>
      )}
    </main>
  );
}
